export default {"src":"/_next/static/media/centers.04049208.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};